import { isEmpty } from 'lodash';
import React from 'react';
import DebouncedText from '../elements/editors/mui/DebouncedText';
import {
  baseSelectStyles,
  getCurrentSelectedOption,
  getNewSelectionValue,
  SelectInput,
  SelectOption,
} from '../elements/rselect/ReactSelectUtils';
import UnsortedSelect from '../elements/rselect/UnsortedSelect';
import { AvailableFilter } from './types/AvailableFilters';
import { Macro } from './types/Macro';

type Props = {
  filter: AvailableFilter;
  macro: Macro;
  onChange: (type: string, value: string) => void;
};

export default function MacroOptionsRow({
  filter: { type, label, availableValues },
  macro: { value },
  onChange,
}: Props) {
  const inputId = `macro-options-field-${type}`;

  function onTextChange(newValue) {
    onChange(type, newValue);
  }

  function onSelectChange(option) {
    onChange(type, getNewSelectionValue(option, true));
  }

  return (
    <div className="macro-options-row">
      <label className="macro-options-row-label" htmlFor={inputId}>
        {label}
      </label>
      <div className="macro-options-row-field">
        {!isEmpty(availableValues) ? (
          <UnsortedSelect
            id={inputId}
            value={getCurrentSelectedOption(availableValues, value)}
            options={availableValues}
            isClearable
            components={{ Input: SelectInput, Option: SelectOption }}
            styles={baseSelectStyles}
            onChange={onSelectChange}
          />
        ) : (
          <DebouncedText
            id={inputId}
            value={value}
            rootStyle={{
              height: '38px',
              backgroundColor: '#fff',
              borderRadius: 8,
            }}
            style={{
              padding: '2px 8px',
              borderColor: '#ccc',
              borderRadius: 8,
            }}
            onChange={onTextChange}
          />
        )}
      </div>
    </div>
  );
}
